// Mirrors Finkit.Permissions.HostPagesPermissions.FinkitHostPagesPermissions.TerminalRequestsManagement.
export const TerminalRequestsPermissions = {
  view: 'HostPages.TerminalRequestsManagement',
  manage: 'HostPages.TerminalRequestsManagement.Manage',
} as const;
